import React from 'react';
import PropTypes from 'prop-types';

const Tile = (props) => (
  <div className="col-12">
    <div className="card border-secondary mb-4">
      <div className="card-header">
        {props.fontName}
      </div>
      <div className="card-body">
        <p className={`card-text ${props.font.toLowerCase()} `} style={{fontFamily: props.font}}>{props.inputText}</p>
        <a href={props.url} className="btn btn-shop-now">Shop Now</a>
      </div>
    </div>
  </div>
);

Tile.propTypes = {
  font: PropTypes.string.isRequired,
  inputText: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  fontName: PropTypes.string.isRequired,
};

export default Tile;


// WEBPACK FOOTER //
// ./src/app/Tile/Tile.js